export const getContentFromCustomCompletePage = (
  value?: string | null
): string => {
  if (!value && value === 'default') return ''
  const match = value?.match(/@content\[(.*?)\]/)
  return (
    match?.[1] ||
    '<h6 style="text-align: center"><strong>Thank you!</strong></h6><h3 style="text-align: center"><span style="color: #999999">Your form has been submitted</span></h3>'
  )
}
